import Router from "./router";
const App = () => {
  return (
    <Router />
  );
}

export default App;
